import { Tag } from '@omnipresentgroup/design-system';
import {
  getTimeOffTypeIntent,
  getTimeOffTypeValue,
  leaveTypeReasons,
  useTimeOffTypes,
} from '@omnipresentgroup/domains';
import { toSentenceCase } from '@omnipresentgroup/helpers';
import type { LeaveType } from '@omnipresentgroup/types';

type Props = {
  leaveType: LeaveType;
};

export const TimeOffLeaveTypeTag = ({ leaveType }: Props) => {
  const { data: genericLeaveTypes } = useTimeOffTypes({});

  const isCustom =
    !genericLeaveTypes?.some(
      (type) => type.name === getTimeOffTypeValue(leaveType),
    ) && !leaveTypeReasons.some((reason) => leaveType === `op:leave:${reason}`);

  return (
    <Tag id={`leave-type-${leaveType}`} intent={getTimeOffTypeIntent(isCustom)}>
      {toSentenceCase(getTimeOffTypeValue(leaveType))}
    </Tag>
  );
};
